export {
  default as enterFullScreenIconTemplate,
} from './enterFullScreenIcon.dot';
export {
  default as exitFullScreenIconTemplate,
} from './exitFullScreenIcon.dot';
export { default as controlTemplate } from './control.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/controls/full-screen/templates/index.ts